import { css } from "emotion";
import CMSComponent from "../../../components/CMSComponent";
import H2 from "../../../components/global/H2";
import P from "../../../components/global/P";
import Banner from "../../../components/layout/Banner";
import Layout from "../../../components/layout/Layout";
import { updateTitle } from "../../../utils/BrowserUtils";
import DescriptionBlock from "../DescriptionBlock";
import Flag from "./componets/Flag";
import HowToHelp from "./componets/HowToHelp";
import HowWeDeliver from "./componets/HowWeDeliver";
import OurImpacts from "./componets/OurImpacts";
import ProjectDeliveryPartners from "./componets/ProjectDeliveryPartners";
import Quote from "./componets/Quote";

const bannerImage = require("../../../assets/Projects/kidscanBanner1.png");

const icFoodForKids = require("../../../assets/Projects/ic_food_for_kids.svg");
const icMaterialSupport = require("../../../assets/Projects/ic_material_support_nz.svg");

const quoteImage = require("../../../assets/Projects/julie_chapman.png");
const kidsCan = require("../../../assets/Projects/kidscanDesc.png");
const partnerLogo = require("../../../assets/Projects/logo_kidscan.png");

const bannerContent = css({
  padding: "0px 0px 0px 80px",
  textAlign: "left",
  h2: {
    maxWidth: 402,
    marginBottom: 16,
    fontSize: 36
  },
  p: {
    maxWidth: 402,
    marginBottom: 20,
    marginLeft: 0,
    fontSize: 18
  },
  "@media(max-width: 1080px)": {
    padding: "112px 0px 24px 80px"
  },
  "@media(max-width: 768px)": {
    padding: "40px 14px 24px 14px",
    h2: {
      fontSize: 22
    },
    p: {
      fontSize: 16
    }
  }
});

const impactsObj = [
  {
    title: "Every ticket counts",
    content: "$2 = 1 meal at school",
    subtext: "all funded from booking fees"
  }
];

const howWeDeliverNutrition = [
  {
    image: icFoodForKids,
    alt: "Food for kids icon",
    title: "Tech for kids",
    title: "Food for kids",
    content:
      "Everything from yoghurt to hot meals is provided to disadvantaged kids in partnership with 740 low decile schools all across Aotearoa New Zealand."
  },
  {
    image: icMaterialSupport,
    alt: "Material support icon",
    title: "Material support",
    content:
      "Beyond food, our programs supply raincoats, shoes, socks and health care for disadvantaged kids – whatever it takes to help kids stay in school."
  }
];

const KidsCan = ({ localeData }) => {
  updateTitle("KidsCan");

  const explanation = [
    "Yet for 290,000 Kiwi children, hunger throughout the school day is a reality.",
    "Children who go to school hungry have difficulties concentrating in class, experience learning difficulties and are more likely to miss school frequently. Teachers estimate that the average student loses more than 2 hours a day of learning time when they come to school hungry.",
    "This can all lead to long-term effects on their life outcomes and impacts their ability to reach their full potential both in and out of the classroom."
  ];

  return (
    <Layout>
      <Banner image={bannerImage} bgColor="greyBackground">
        <div className={bannerContent}>
          <H2 marginBottom={16} marginBottomMobile={12}>
            Nutrition for Kiwi School Kids
          </H2>
          <P>
            Every day in New Zealand, one child in every classroom goes to
            school hungry. So we’re equipping kids with the food and equipment
            needed to make school work for them.
          </P>
        </div>
      </Banner>

      <OurImpacts data={impactsObj} />

      <DescriptionBlock
        heading="No child can be expected to learn on an empty stomach"
        alt="Girl smiling whilst working on computer at school"
        image={kidsCan}
        text={explanation}
      />

      <HowWeDeliver
        header="How we deliver our nutrition program"
        data={howWeDeliverNutrition}
      />

      <HowToHelp
        localeData={localeData}
        text="We’re a unique charity, in that we don’t ask for donations (though you are welcome to offer). "
      />

      <ProjectDeliveryPartners>
        <P>
          We believe in impact with evidence, not just good intentions. That’s
          why we work with expert delivery partners, to make sure all our
          projects are making long-lasting, systemic change.
        </P>
        <Flag>
          <img src={partnerLogo} alt="KidsCan logo" />
          <P>
            Our nutrition for kiwi school kids program is delivered in
            partnership with KidsCan’s networks of 740 low-decile schools and
            suppliers of food and equipment.
          </P>
        </Flag>
        <Quote
          image={quoteImage}
          imageAlt="Picture of Julie Chapman."
          quote='"Education is a major route out of hardship."'
          author="Julie Chapman, CEO & Trustee of KidsCan"
        />
      </ProjectDeliveryPartners>
    </Layout>
  );
};

export default CMSComponent(null, KidsCan);
